import { render, staticRenderFns } from "./GroupListOld.vue?vue&type=template&id=3dd2176e&scoped=true"
import script from "./GroupListOld.vue?vue&type=script&lang=js"
export * from "./GroupListOld.vue?vue&type=script&lang=js"
import style0 from "./GroupListOld.vue?vue&type=style&index=0&id=3dd2176e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2176e",
  null
  
)

export default component.exports